/***
 *Â @FileName: é£ä¹¦èå
 *Â @Author: manyao.zhu
 *Â @Date: 2020-06-11 16:56:02
 */
import { Component, Input, OnInit } from '@angular/core';

import { SettingsService } from '@ithinkdt/shared/browser';
import { isEmpty } from '@ithinkdt/shared/utils';
import { ValidMenu } from '@ithinkdt/theme/models';

import { MenuConfig } from '../feishu.model';

@Component({
  selector: 'dt-feishu-menu',
  templateUrl: './feishu-menu.component.html',
  styleUrls: ['./feishu-menu.component.scss'],
})
export class FeishuMenuComponent implements OnInit {
  validMenuList: ValidMenu[];
  showSystemMenu = false;
  @Input() menuData: MenuConfig[];

  constructor(private settingSrv: SettingsService) {}

  ngOnInit() {
    if (!isEmpty(this.settingSrv.menu)) {
      this.validMenuList = this.getValidMenu(this.settingSrv.menu);
    }
  }

  getValidMenu(menuTree = []): ValidMenu[] {
    const validMenuList: ValidMenu[] = [];
    menuTree.forEach((m) => {
      const { action, moduleName, moduleNameEn, children } = m;
      if (action && moduleName) {
        validMenuList.push({
          router: action,
          moduleName,
          moduleNameEn,
        });
      }
      if (m.hasChildren) {
        validMenuList.push(...this.getValidMenu(children));
      }
    });
    return validMenuList;
  }

  close() {
    this.showSystemMenu = false;
  }
}
